import { useQuery } from "react-query";
import type { UseQueryResult } from "react-query";
import type { RangeStatsDto } from "common/models/api/models/RangeStatsDto";
import useUserState from "ui/adapter/state/useUserState";
import { Queries } from "ui/query/queries";
import type { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { RoleType } from "common/models/role/Role";
import { usersApi } from "../api/usersApi";

export type UseUserStatsQueryKey = [typeof Queries.USERS_STATS, string | undefined];

export default function useUserStats<TData = RangeStatsDto>({
    enabled = true,
    ...options
}: UseCustomQueryOptions<RangeStatsDto, unknown, TData, UseUserStatsQueryKey> = {}): UseQueryResult<TData> {
    const { selectedRole } = useUserState();
    return useQuery(
        [Queries.USERS_STATS, selectedRole?.roleType],
        async () => {
            const res = await usersApi.getUsersByDay(selectedRole?.resourceAddress, 30, selectedRole?.roleType);
            return res.data;
        },
        {
            enabled:
                enabled &&
                (selectedRole?.roleType === RoleType.ORGANIZATION_OWNER ||
                    selectedRole?.roleType === RoleType.PROGRAM_MANAGER ||
                    selectedRole?.roleType === RoleType.OPERATION_MANAGER ||
                    selectedRole?.roleType === RoleType.CUSTOMER_SERVICE),
            ...options,
        },
    );
}
